export class HttpError extends Error {
  readonly status: number;
  readonly statusText: string;
  readonly errorCode: string | null;
  readonly body: unknown;

  constructor(status: number, statusText: string, body: unknown) {
    const errorCode = extractErrorCode(body);
    const message = extractMessage(body) ?? `${status} ${statusText}`;
    super(message);
    this.name = 'HttpError';
    this.status = status;
    this.statusText = statusText;
    this.errorCode = errorCode;
    this.body = body;
  }
}

function extractErrorCode(body: unknown): string | null {
  if (body && typeof body === 'object') {
    const code = (body as Record<string, unknown>).error_code ?? (body as Record<string, unknown>).errorCode;
    if (typeof code === 'string') return code;
  }
  return null;
}

function extractMessage(body: unknown): string | null {
  if (body && typeof body === 'object') {
    const msg = (body as Record<string, unknown>).message ?? (body as Record<string, unknown>).error;
    if (typeof msg === 'string') return msg;
  }
  return null;
}

export class NotImplementedError extends Error {
  constructor(method: string) {
    super(`${method} is not implemented in the cloud-agent backend yet.`);
    this.name = 'NotImplementedError';
  }
}
